import { useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'

import styles from 'app/App.module.scss'
import { AnalyticsActionType } from 'types/common/analytics.type'

import BottomArc from '../components/common/ArcBottom/ArcBottom'
import HeroBanner from '../components/heroBanner/HeroBanner'
import InnovationSubhead from '../components/innovationSubhead/InnovationSubhead'
import OpportunitySubhead from '../components/opportunitySubhead/OpportunitySubhead'
import PartnersSubhead from '../components/partnersSubhead/PartnersSubhead'
import ProjectsSubhead from '../components/projectsSubhead/ProjectsSubhead'
import VideoSliderComponent from '../components/videoSliderSubhead/videoSliderComponent'
import { EVENTS, trackAnalytics } from '../utils/analytics'

export function App() {
  useEffect(() => {
    trackAnalytics({
      type: AnalyticsActionType.page,
      payload: EVENTS.INNOVATION_PAGE,
    })
  }, [])

  return (
    <BrowserRouter basename="/innovation-process">
      <HeroBanner />
      <div className={styles.container}>
        <OpportunitySubhead />
        <InnovationSubhead />
        <ProjectsSubhead />
        <PartnersSubhead />
        <VideoSliderComponent />
        <BottomArc />
      </div>
    </BrowserRouter>
  )
}
